module.exports = __webpack_public_path__ + "static/media/MagicMirrorFootball.e3bfac0c.png";